import { useMutation, useQuery, useQueryClient } from "react-query";

import {
  callListRobot,
  callUpdateRobot,
} from "api/worker/robot";
import { robotKey } from "./keys";
import { CleaningRobotList } from "types/response/robot";

type ListParams = {
  enabled?: boolean;
};

export const useListRobotQuery = (input?: ListParams) => {
  return useQuery({
    queryKey: robotKey.list(),
    queryFn: callListRobot,
    enabled: input?.enabled ?? true,
  });
};

// export const useUpdateRobotSettingMutation = () => {
//   const queryClient = useQueryClient();

//   return useMutation(callUpdateRobotSetting, {
//     onSuccess: (_updated, variables) => {
//       queryClient.setQueryData<CleaningRobotList | undefined>(
//         robotKey.list(),
//         (prev) => {
//           if (!prev) return undefined;
//           return prev.map((r) =>
//             r.robotId === variables.robotId
//               ? {
//                   ...r,
//                   volume: variables.volume,
//                   fanMode: variables.fanMode,
//                 }
//               : r
//           );
//         }
//       );
//     },
//   });
// };

export const useUpdateRobotMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(callUpdateRobot, {
    onSuccess: (_updated, variables) => {
      queryClient.setQueryData<CleaningRobotList | undefined>(
        robotKey.list(),
        (prev) => {
          if (!prev) return undefined;
          return prev.map((r) =>
            r.robotId === variables.robotId
              ? {
                  ...r,
                  robotName: variables.robotName,
                  description: variables.description,
                }
              : r
          );
        }
      );
    },
  });
};
